export default class GPartType {
    id = 1;
    name = '-';
}